<ng-template #testingSiteModal>
  <p>
    This message is to inform you that you are connected to the testing database. If this was not your intent, please try flushing your browser cache and reload the web app.
    <br>
    <a href="https://app.researcharsenal.com">Live site</a><br>
    <a href="https://testing.researcharsenal.com">Testing site</a>
  </p>
  <p>
    Currently loaded version info: <label>{{ version }}</label>
  </p>
</ng-template>

<ng-template #helpAboutModal>
  <img src="../assets/login-logo.png" style="z-index: -1;" >
  <h3 class="mt-1">
    A premier Civil War database at your fingertips.
  </h3>
  <br>
  <div class="text-center">
    <a style="display: inline;" class="me-2" (click)="launchContactUsForm('Contact Us')">Contact Us</a>
    &middot;
    <a href="https://researcharsenal.com/faqs/" target="_blank" rel="noopener noreferrer" style="display: inline;" class="ms-2" title="Frequently Asked Questions">
      FAQ
      <i class="fal fa-sm fa-external-link ms-1 text-muted" style="vertical-align: super;"></i>
    </a>
  </div>
  <hr>
  <p class="mt-1 mb-1">
    <label style="font-size: 1rem;">{{ version }}</label>
  </p>
  <hr>
  <small class="text-muted">
    <img src="../assets/android-chrome-Favicon.192x192.png" style="display: inline; height: 55px; vertical-align: middle;">
    Powered by <a href="http://stellarstarbase.com" target="_blank" rel="noopener noreferrer"><em class="Stellar">Stellar StarBase</em></a>. 
    <br>
    <img src="../assets/Stellar_JustStar.png" style="display: inline; height: 55px; vertical-align: middle;"> Web app developed by <a href="https://stellarstar.com" target="_blank" rel="noopener noreferrer"><em class="Stellar">Stellar Programming &amp; Consulting, Inc.</em></a> &copy; {{ currentYear }} &nbsp; <a href="https://stellarstar.com" target="_blank" rel="noopener noreferrer">StellarStar.com</a>
    <br>
    <span class="Bark" style="color: black;"></span>
    <a href="https://thebarkfirm.com" target="_blank" rel="noopener noreferrer">
      <img src="../../assets/BARKWebFooter_trimmed.png" style="filter: invert(); display: inline; vertical-align: middle;" class="ms-1 mt-3" alt="Graphics by The Bark Firm" />
    </a>
    <br>
  </small>
  <br>
  <hr>
  &copy; {{ today.getFullYear() }} &mdash; RESEARCH ARSENAL, All Rights Reserved
</ng-template>

<lib-starbase-modal-overlay [zIndex]="202" [glassMode]="glassMode" [darkMode]="darkMode" [overlayEnabled]="overlayEnabled"></lib-starbase-modal-overlay>
<lib-starbase-notification #StarbaseNotificationComponent [styleMode]="notificationStyleMode" [darkMode]="darkMode" [glassMode]="glassMode"></lib-starbase-notification>
<lib-starbase-modal-dialog #mainModalDialog [zIndex]="212" [animate]="true" [glassMode]="glassMode" [darkMode]="darkMode"></lib-starbase-modal-dialog>

<ng-template #menuLinks>
  <ul class="navbar-nav ms-5 me-auto">
    <li class="nav-item mainMenu" [routerLinkActive]="'active'">
      <a href="#" [routerLink]="'/gateway'" [routerLinkActive]="['activeLink']" class="nav-link">
        Libraries
      </a>
    </li>
    <li class="nav-item mainMenu" [hidden]="!galleryPage || (galleryPage === '')" [routerLinkActive]="'active'">
      <a href="#" [routerLink]="'/library'" [routerLinkActive]="['activeLink']" class="nav-link">
        Gallery
        <small id="galleryPage">({{ galleryPage }})</small>
      </a>
    </li>
    <li class="nav-item mainMenu" [routerLinkActive]="'active'">
      <a href="#" [routerLink]="'/search'" [routerLinkActive]="['activeLink']" class="nav-link">
        Catalog
        <small id="microfilm" [hidden]="!microfilmSearchActive">(NARA Records)</small>
      </a>
    </li>
    <li class="nav-item mainMenu active" disabled [hidden]="currentRoute.indexOf('/imageSingleView') === -1">
      <a aria-disabled="true" [routerLink]="'/imageSingleView/' + currentRouteId" class="nav-link activeLink">
        Record Viewer
      </a>
    </li>
    <li *ngIf="isAdmin || loggedInUser.isInUserGroup('Librarian')" class="nav-item mainMenu" [routerLinkActive]="'active'">
      <a [routerLink]="'/lookup-tables'" [routerLinkActive]="['activeLink']" class="nav-link">
        Lookup Tables
      </a>
    </li>
    <li *ngIf="isAdmin" class="nav-item mainMenu" [routerLinkActive]="'active'">
      <a [routerLink]="'/dashboard'" [routerLinkActive]="['activeLink']" class="nav-link">
        Dashboard
      </a>
    </li>
    <li *ngIf="isAdmin" class="nav-item mainMenu" [routerLinkActive]="'active'">
      <a [routerLink]="'/logs'" [routerLinkActive]="['activeLink']" class="nav-link">Logs</a>
    </li>
    <li *ngIf="!isAdmin && isTrialUser" class="nav-item mainMenu">
      <a class="nav-link" (click)="handleJoinNowPath()">
        <i class="fas fa-chevron-double-up me-1"></i>
        <strong>UPGRADE</strong>
      </a>
    </li>
    <li class="nav-item mainMenu">
      <a class="nav-link" href="https://researcharsenal.com/faqs/" target="_blank" rel="noopener noreferrer" title="Frequently Asked Questions">
        Getting Started/Help
      </a>
    </li>
  </ul>
</ng-template>

<ng-template #appDropdown id="appDropdown">

  <li *ngFor="let menu of menuBarItems">
    <div *ngIf="menu.divider === true; else menuItem" class="dropdown-divider" [style.color]="menu.colorCssString"></div>
      <ng-template #menuItem>
        <a [ngClass]="{'disabledAnchor': !menu.enabled}"
        [routerLink]="menu.routerLink"
        (click)="callClickAction(menu)"
        [style.color]="menu.colorCssString"
        class="dropdown-item"
        [ngClass]="{'darkMode': darkMode}">
          <i [class]="iconStyle + ' ' + menu.iconClass"></i>
          <span [matTooltip]="menu.tooltip" [matTooltipShowDelay]="tooltipDelay" [matTooltipPosition]="'left'">
            {{ menu.displayText }}
          </span>
          <i *ngIf="menu.external" class="fal fa-sm fa-external-link ms-1 text-muted" style="vertical-align: super;" title="Opens externally"></i>
        </a>
      </ng-template>
  </li>

</ng-template>

<ng-template #mobileMenuLinks id="mobMenuLinks">

    <li>
      <a href="#" [routerLink]="'/gateway'" class="link1" [routerLinkActive]="['activeLink']" >
        Libraries
      </a>
      <div style="border-top: 1px solid rgba(50, 50, 50, 0.2); margin: 5px 0; height: 1px; padding: 0; list-style: none;"></div> 
    </li>


    <li [hidden]="!galleryPage || (galleryPage === '')">
      <a href="#" [routerLink]="'/library'" class="link1"  [routerLinkActive]="['activeLink']" >
        Gallery
        <small id="galleryPage">({{ galleryPage }})</small>
      </a>
      <div style="border-top: 1px solid rgba(50, 50, 50, 0.2); margin: 5px 0; height: 1px; padding: 0; list-style: none;"></div> 
    </li>

    <li>
      <a href="#" [routerLink]="'/search'" [routerLinkActive]="['activeLink']" class="link1">
      Search
        <small id="microfilm" [hidden]="!microfilmSearchActive">(NARA Records)</small>
      </a>
      <div style="border-top: 1px solid rgba(50, 50, 50, 0.2); margin: 5px 0; height: 1px; padding: 0; list-style: none;"></div> 
    </li>


    <li [hidden]="currentRoute.indexOf('/imageSingleView') === -1">
      <a aria-disabled="true"  [routerLink]="'/imageSingleView/' + currentRouteId" [routerLinkActive]="['activeLink']" class="link1 activeLink">
        Record Viewer
      </a>
      <div style="border-top: 1px solid rgba(50, 50, 50, 0.2); margin: 5px 0; height: 1px; padding: 0; list-style: none;"></div> 
    </li>

    <!-- <li *ngIf="isAdmin || loggedInUser.isInUserGroup('Librarian')">
      <a [routerLink]="'/lookup-tables'" [routerLinkActive]="['activeLink']" class="link1">
        Lookup Tables
      </a>
    </li>

    <li *ngIf="isAdmin">
      <a [routerLink]="'/dashboard'" [routerLinkActive]="['activeLink']" class="link1">
        Dashboard
      </a>
    </li>

    <li *ngIf="isAdmin">
      <a  [routerLink]="'/logs'" [routerLinkActive]="['activeLink']" class="link1">Logs</a>
    </li> -->

    <li *ngIf="!isAdmin && isTrialUser">
      <a class="link1" (click)="handleJoinNowPath()">
        <i class="fas fa-chevron-double-up me-1"></i>
        <strong>UPGRADE</strong>
      </a>
      <div style="border-top: 1px solid rgba(50, 50, 50, 0.2); margin: 5px 0; height: 1px; padding: 0; list-style: none;"></div> 
    </li>

    <li>
      <a class="link1" href="https://researcharsenal.com/faqs/" target="_blank" rel="noopener noreferrer" title="Frequently Asked Questions">
        Getting Started/Help
      </a>
    </li>

</ng-template>

 
<ng-template #brand>
  <div class="brandWrapper" (click)="raHomepage()" [title]="version" [ngClass]="{'mobile': isHandset}">
    <img [src]="currentRoute.includes('login') ? '../assets/login-logo.png' : '../assets/ra-logo.png'" alt="Research Arsenal logo" [ngClass]="{'mobile': isHandset}">
  </div>
</ng-template>

<ng-template #optionsModal>
  <tabset>
    <tab heading="Site Preferences" class="mt-2">
      <!-- <h5>
        <i class="fad fa-adjust me-1"></i>
        Appearance
      </h5>
      <div class="btn-group" role="group">
        <label role="button" [ngClass]="{'active': !darkMode && !glassMode}" tabindex="0" (click)="setStyle('normal')" class="btn btn-info">
          <i class="fal fa-sun me-1"></i>
          Normal
        </label>
        <label role="button" [ngClass]="{'active': darkMode}" tabindex="0" (click)="setStyle('dark')" class="btn btn-info">
          <i class="fal fa-moon-stars me-1"></i>
          Dark
        </label>
      </div>
      <hr> -->      <h5>
        <i class="fal fa-lightbulb"></i>
        Tooltips
      </h5>      
      <label for="tooltipDelaySlider">Delay before tooltips appear (in seconds): {{ currentSliderValue }}s</label>
      <br>
      <mat-slider class="ra-slider" style="width: 250px;" id="tooltipDelaySlider" step="0.5" min="0" max="3" [value]="currentSliderValue" (valueChange)="setTooltipDelay($event)">
        <input matSliderThumb [(ngModel)]="currentSliderDisplayValue" (ngModelChange)="setTooltipDelay($event)">
      </mat-slider>
      <!-- <button class="btn btn-info btn-sm ms-3" [matTooltipShowDelay]="tooltipDelay" matTooltip="I'm a sample tooltip!">Hover over me to test</button> -->
      <app-slant-button [linkMode]="true" [matTooltip]="'I\'m a sample tooltip!'" [matTooltipShowDelay]="tooltipDelay">
        Hover over me to test
      </app-slant-button>
      <br>
      <small *ngIf="reloadRequired" class="text-info">
        <i class="fal fa-info me-1"></i>
        <i class="fal fa-redo me-1"></i>
        You must reload the app for this change to take effect.
      </small>
      <hr>
      <h5 class="mt-2">
        <i class="fal fa-globe-americas me-1"></i>
        Timezone Settings
      </h5>
      <div class="form-group">        
        <mat-form-field appearance="outline" floatLabel="auto">
          <mat-label>{{ userTimeZone ? userTimeZone.name : 'Set your timezone' }}</mat-label>
          <mat-select disableRipple [value]="userTimeZone" (selectionChange)="changeTimezone($event.value)">
            <mat-option *ngFor="let tz of usTimezones" [value]="tz">
              {{ tz.name }} (GMT{{ userDST ? tz.DSToffset : tz.offset }})
            </mat-option>
          </mat-select>
        </mat-form-field>
        <label for="dstCheckbox" matTooltip="Daylight Saving Time" class="me-1 ms-2"> DST </label>
        <button type="button" matTooltip="Daylight Saving Time" btnCheckbox class="btn btn-outline-info" [(ngModel)]="userDST">
          <i class="fal" [ngClass]="{'fa-check': userDST}"></i>
        </button>
      </div>
      <hr style="border-color: #111;">
      <h6>
        <app-slant-button tooltip="Clear your preferences stored in this browser" linkMode="true" (click)="clearPrefs()" [btnIconClass]="'fa-minus-octagon'">
          Reset Preferences
        </app-slant-button>
        <!-- <button class="btn btn-sm btn-warning" matTooltip="Clear all your preferences stored in this browser." type="button" (click)="clearPrefs()">
          <i class="fal fa-minus-octagon me-1"></i>
          Reset Preferences
        </button> -->
      </h6>
    </tab>
    <tab heading="User Settings" class="mt-2" style="min-width: 1100px;" [active]="openOnUser">
      <ng-container *ngTemplateOutlet="acctMgmtWrapper"></ng-container>
    </tab>
    <tab heading="Dashboard" class="mt-2" *ngIf="isAdmin">
      <a class="btn btn-sm btn-link me-1" style="border: 1px solid;" [matTooltipShowDelay]="tooltipDelay" matTooltip="(This will close the options dialog)" (click)="openDashboardSettings()">
        <i class="fal fa-tachometer-fastest"></i><i class="fal fa-cog me-1"></i>
        Open Dashboard Customizations
      </a>
    </tab>
    <tab heading="Email Subscriptions" class="mt-2" (selectTab)="loadSubs()">
      <h5>
        <i class="fal fa-envelope-open-text me-1"></i>
        Your Email Subscriptions
        <table *ngIf="dashSubs$ | async; else loadingSubs" class="table table-borderless" [style.color]="darkMode ? '#eee' : '#000'">
          <thead style="text-decoration: underline;">
            <th>Module</th>
            <th>Subscription</th>
            <th>Subscribed</th>
          </thead>
          <tr *ngFor="let sub of dashSubs$ | async">
            <td>{{sub.module}}</td>
            <td>{{sub.subName}}</td>
            <td>
              <button type="button" class="btn btn-sm btn-dark"
              [(ngModel)]="sub.subscribed" matTooltip="Click to toggle subscription state" btnCheckbox (click)="dashSubSvc.toggleSubscription(sub.module, sub.subName, currentUserAccount.uid)">
                <i class="fal fa-check" [style.color]="sub.subscribed ? 'lightgreen': 'transparent'"></i>
              </button>
            </td>
          </tr>
        </table>
        <ng-template #loadingSubs>
          <label>Loading...</label>
        </ng-template>
      </h5>
    </tab>
  </tabset>
</ng-template>

<ng-template #optionsModalMobile>

  <div class="header-dropdown-container">
    <mat-form-field appearance="fill" class="header-dropdown">
      <mat-select [(value)]="selectedUserAccountOption" (selectionChange)="onSelectionChange($event.value)">
        <mat-select-trigger>
          <span class="selected-item">{{ selectedUserAccountOption }}</span>
        </mat-select-trigger>
        <mat-option *ngFor="let option of userAccountOptions" [value]="option">{{ option }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="template-container">    
    <ng-container *ngIf="selectedUserAccountOption === 'Site Preferences'">        
      <h5>
        <i class="fal fa-lightbulb"></i>
        Tooltips
      </h5>
      <label for="tooltipDelaySlider">Delay before tooltips appear (in seconds): {{ currentSliderValue }}s</label>
      <br>
      <mat-slider class="ra-slider" style="width: 250px;" id="tooltipDelaySlider" step="0.5" min="0" max="3" [value]="currentSliderValue" (valueChange)="setTooltipDelay($event)">
        <input matSliderThumb [(ngModel)]="currentSliderDisplayValue" (ngModelChange)="setTooltipDelay($event)">
      </mat-slider>
  
      <app-slant-button [linkMode]="true" [matTooltip]="'I\'m a sample tooltip!'" [matTooltipShowDelay]="tooltipDelay">
        Hover over me to test
      </app-slant-button>
      <br>
      <small *ngIf="reloadRequired" class="text-info">
        <i class="fal fa-info me-1"></i>
        <i class="fal fa-redo me-1"></i>
        You must reload the app for this change to take effect.
      </small>
      <hr>
      <h5 class="mt-2">
        <i class="fal fa-globe-americas me-1"></i>
        Timezone Settings
      </h5>
      <div class="form-group">        
        <mat-form-field appearance="outline" floatLabel="auto">
          <mat-label>{{ userTimeZone ? userTimeZone.name : 'Set your timezone' }}</mat-label>
          <mat-select disableRipple [value]="userTimeZone" (selectionChange)="changeTimezone($event.value)">
            <mat-option *ngFor="let tz of usTimezones" [value]="tz">
              {{ tz.name }} (GMT{{ userDST ? tz.DSToffset : tz.offset }})
            </mat-option>
          </mat-select>
        </mat-form-field>
        <label for="dstCheckbox" matTooltip="Daylight Saving Time" class="me-1 ms-2"> DST </label>
        <button type="button" matTooltip="Daylight Saving Time" btnCheckbox class="btn btn-outline-info" [(ngModel)]="userDST">
          <i class="fal" [ngClass]="{'fa-check': userDST}"></i>
        </button>
      </div>
      <hr style="border-color: #111;">
      <h6>
        <app-slant-button tooltip="Clear your preferences stored in this browser" linkMode="true" (click)="clearPrefs()" [btnIconClass]="'fa-minus-octagon'">
          Reset Preferences
        </app-slant-button>

      </h6>
    </ng-container>

    <ng-container *ngIf="selectedUserAccountOption === 'User Settings'">
      <ng-container *ngTemplateOutlet="acctMgmtWrapper"></ng-container>
    </ng-container>

  </div>
</ng-template>


<ng-template #acctMgmtWrapper>
  <div>
    <lib-account-management #acctMgmt
      [userId]="editUserId"
      [userDashDataService]="this.userSvc"
      [contactDashDataService]="this.contactSvc"
      [isAdmin]="this.isAdmin"
      [imageUpdateSvc]="imageUpdateSvc"
      accentColor="#1b1b1b"
      [subscriptionBasedApp]="true"
      [passwordScorerFn]="score"
      [minimumPwdScore]="appMinimumPwdScore"
      [minimumPwdLength]="appMiniumPwdLength"
      [darkMode]="this.darkMode"
      [glassMode]="this.glassMode"
      [openOnTab]="currentAccountTab"
      [fileUploadMode]="this.fileUploadMode"
      [subscriptionTabOverride]="subscriptionOverride"
      (messageEmitter)="this.sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
      (cancelSubscriptionEmitter)="handleSubscriptionCancel()"
      (manageSubscriptionEmitter)="handleSubscriptionManage()"
      (requestRecordHistoryEmitter)="handleRecordHistoryRequest($event)"></lib-account-management>
  </div>
</ng-template>

<ng-template #recordHistoryModal>
  <lib-new-table-editor #mainLogs
  modelName="Entity record history"
  (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
  [userViewOptions]="recordHistoryViewOpts"
  [usePagination]="true"
  [loadAllClientside]="false"
  [tableEditable]="false"
  [dataSvc]="logSvc"
  [rppChoices]="[5, 25, 50, 100]"
  [columns]="recordHistoryCols"
  [dataFilterParams]="recordHistoryData">
    <h6>
      {{ logSvc.lastRetrievedEntityName }}
    </h6>
    <span class="small text-muted">
      Guid: {{ recordHistoryData?.filters[0][1] }}
    </span>
    <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="logCols" let-compactMode="compactMode" let-tableViewOptions="tableViewOptions">
      <span style="display: contents;" lib-table-row
      [rowData]="rowData"
      [columnDefinitions]="recordHistoryCols"
      [allowEdit]="false"
      [compactMode]="compactMode"
      [tableViewOptions]="tableViewOptions"
      ></span>
    </ng-template>
  </lib-new-table-editor>
</ng-template>

<ng-template #paymentModal>
  <app-fortis-payment-form [userAccount]="subUserAcct" [chosenPlan]="this.subPlan" [darkMode]="darkMode"></app-fortis-payment-form>
</ng-template>

<ng-template #cancelSubModal>
  <h4>
    Are you sure you want to cancel your <em>{{ subUserAcct?.subscriptionRecord?.subscriptionPrice?.name }}</em> subscription to Research Arsenal?
  </h4>
  <p>
    If you cancel, you will still have access to Research Arsenal through the remainder of the billing cycle <strong>({{ subUserAcct?.subscriptionExpiryDate | date : 'shortDate' }})</strong>.<br>
    After that period, you will be returned to the <em>Free</em> (trial) plan.
  </p>
  <p>After cancelling, you will not be charged again unless you resubscribe.</p>
  <h6>Cancellation Reason:</h6>
  <input type="checkbox" id="money" class="editable" style="margin-right: 1em;" [(ngModel)]="cancelMoney">
  <label for="money">Saving Money</label><br>
  <input type="checkbox" id="content" class="editable" style="margin-right: 1em;" [(ngModel)]="cancelContent">
  <label for="content">Not enough content/Didn't find what I was looking for</label><br>
  <input type="checkbox" id="found" class="editable" style="margin-right: 1em;" [(ngModel)]="cancelFound">
  <label for="found">Found everything I was looking for</label><br>
  <input type="checkbox" id="other" class="editable" style="margin-right: 1em;" [(ngModel)]="cancelOther">
  <label for="other">Other: <input type="text" class="editable" style="width: 20em;" placeholder="Please tell us why you're cancelling" [(ngModel)]="cancellationReason"></label><br>
</ng-template>

<ng-template #subscriptionPlanChoiceModal>
  <app-plan-choices [subUserAcct]="subUserAcct" [devOrTestingMode]="devOrTestingMode" [isHandset] = "isHandset" (subscriptionCancelEvent)="handleSubscriptionCancel(subUserAcct)" (openPaymentFormEvent)="openPaymentForm(subUserAcct, $event)"></app-plan-choices>
</ng-template>

<ng-template #paymentMethodModal>
  <app-fortis-manage-payment [newUserMode]="false" [userAccount]="subUserAcct" [darkMode]="darkMode"></app-fortis-manage-payment>
</ng-template>
<ng-template #donePaymentBtnTemplate let-btnClick="btnClick" let-working="working">
  <app-slant-button [disabled]="working" linkMode="true" (click)="btnClick()">Done</app-slant-button>
</ng-template>
<ng-template #basicOkayBtnTemplate let-working="working" let-btnClick="btnClick">
  <app-slant-button [disabled]="working" linkMode="true" (click)="btnClick()">Okay</app-slant-button>
</ng-template>
<ng-template #logoutBody>
  <p>In order to apply your subscriber benefits, you will need to log back in. Press Continue to proceed to the Login page.</p>
</ng-template>

<ng-template #subscriptionOverride let-userAccount> <!-- Custom subscription section on AcctMgmt cmp -->
  <h5 *ngIf="userAccount.subscriptionRecord && userAccount.isSubscriptionActive; else nag">
    <i class="fal fa-fw fa-lg fa-user me-1"></i>
    You are currently subscribed to our {{ userAccount.subscriptionRecord?.subscriptionPrice?.name }} plan.
  </h5>
  <ng-template #nag>
    <h5>
      <i class="fal fa-info text-info me-1"></i>
      Subscribe now to see detailed image data and unlock many other features!
    </h5>
    <h5>
      <i class="fal fa-fw fa-lg fa-watch me-1"></i>
      You are currently a limited access Trial User.
    </h5>
  </ng-template>
  <h5 *ngIf="userAccount.subscribed">
    <i class="fal fa-fw fa-lg fa-calendar-day me-1"></i>
    Your next renewal date is {{ userAccount.subscriptionRecord?.subscriptionExpires | date : 'shortDate' }}.
  </h5>
  <h5 *ngIf="userAccount.subscribed">
    <i class="fal fa-fw fa-lg fa-credit-card me-1"></i>
    Your card will be charged <strong>${{ formatAsDecimal(userAccount.subscriptionRecord?.renewalPrice, 2)}}</strong> on that date.
  </h5>
  <p *ngIf="!userAccount.subscribed && userAccount.isSubscriptionActive">
    <i class="fal fa-fw fa-lg fa-exclamation-triangle text-warning me-1"></i>
    Your subscription will not automatically renew and you will lose access on <strong>{{ userAccount.subscriptionRecord?.subscriptionExpires | date : 'shortDate' }}</strong>.
    <br>
  </p>
  <button class="btn warn me-1" [ngClass]="{'btn-outline-warning': !darkMode && !glassMode, 'btn-warning': darkMode, 'btn-light': glassMode, 'disabled': !userAccount.subscribed}"
  *ngIf="userAccount.subscribed"
  [disabled]="!userAccount.subscribed" type="button"
  (click)="handleSubscriptionCancel(userAccount)">
    <i class="fal fa-times-circle me-1"></i>
    Cancel subscription
  </button>
  <!-- <button class="btn success me-1"
  [ngClass]="{'btn-outline-success': !darkMode && !glassMode, 'btn-success': darkMode, 'btn-light': glassMode}"
  type="button" (click)="handleSubscriptionManage(userAccount)">
    <i class="fad fa-chevron-double-up me-1"></i>
    {{ subscribeBtnText(userAccount) }}
  </button> -->
  <app-slant-button linkMode="true" (click)="handleSubscriptionManage(userAccount)">
    <i class="fad fa-chevron-double-up me-1"></i>
    {{ subscribeBtnText(userAccount)}}
  </app-slant-button>
  <app-slant-button linkMode="true" btnIconClass="fa-credit-card-front" tooltip="Update or remove payment method" (click)="openPaymentMethod(userAccount)">
    Update payment
  </app-slant-button>
  <!-- <button class="btn" [ngClass]="{'btn-outline-secondary': !darkMode && !glassMode, 'btn-secondary': darkMode, 'btn-light': glassMode}"
  matTooltip="Update or remove payment method"
  (click)="openPaymentMethod(userAccount)"
   type="button">
    <i class="fal fa-credit-card-front me-1"></i>
    Update payment
  </button> -->
  <br>
  <div class="badge badge-pill badge-success mt-3 mb-1" *ngIf="userAccount.memberSince">
    Member since {{ userAccount.memberSince | date : 'shortDate' }}
  </div>
  <div class="badge badge-pill badge-info mt-3 mb-1 ms-1" *ngIf="userAccount.subscribed && !userAccount.subscriptionRecordUID && !userAccount.subscriptionRecord">
    FREE account
  </div>
  <div class="mt-3 mb-1" *ngIf="isAdmin">
    <button class="btn btn-link" (click)="requestTxnHistory(userAccount.uid)">
      <i class="fal fa-sm fa-line-columns me-1"></i>
      See user's transaction logs
    </button>
    <button class="btn btn-link ms-3" [disabled]="!userAccount.subscriptionRecord" (click)="requestUserSubHistory(userAccount.subscriptionRecord)">
      <i class="fal fa-sm fa-history me-1"></i>
      See user's subscription record history
    </button>
  </div>
  <div class="tableHolder" *ngIf="requestedTxnHist">
    <lib-new-table-editor #txnByUserAcct
    [tableEditable]="false" [dataSvc]="txnLogSvc" [usePagination]="true" [loadAllClientside]="false"
    [dataFilterParams]="txnLogHistFilter" [rppChoices]="[5, 10, 25, 50, 100]" [tableHeight]="'275px'"
    [darkMode]="darkMode" [glassMode]="glassMode"
    [columns]="txnLogCols" [userViewOptions]="txnLogViewOpts" modelName="User's transaction log">
      <h5>{{ userAccount?.userName }}'s transaction log history</h5>
      <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="txnLogCols" let-editRow="editRow" let-tableViewOpts="tableViewOptions">
        <span style="display: contents;" lib-table-row
        [rowData]="rowData"
        [columnDefinitions]="txnLogCols"
        [editRow]="editRow"
        [tableViewOptions]="tableViewOpts"
        [allowEdit]="false">
        </span>
      </ng-template>
    </lib-new-table-editor>
  </div>
</ng-template>

<ng-template #CUButtons let-submitMethod="submitMethod" let-cancelMethod="cancelMethod" let-valid="valid" let-request>
  <!-- <div style="float: left; margin-left: 1em; vertical-align: top;">
    <small>* Required Field</small>
  </div> -->
    <app-slant-button style="float: right;" class="mt-3 pe-1 ms-2"
      [submitMode]="true"
      [leftMode]="false"
      [btnIconClass]="'fa-check'"
      [btnColor]="'green'"
      linkMode="true"
      [disabled]="!valid"
      (click)="submitMethod()">Submit</app-slant-button>
  
    <app-slant-button style="float: right;" class="mt-3 me-1"
      [btnIconClass]="'fa-times'"
      [btnColor]="'yellow'"
      linkMode="true"
      (click)="cancelMethod()">Cancel</app-slant-button>
</ng-template>
<!--<app-pull-to-refresh (pulled)="onPull()" style="background: rgb(229, 230, 231); height: 100%; overflow-y: auto; display: inherit;">-->
  <div *ngIf="contactUsModalOpen" class="contactUsModal">
    <lib-contact-us-form #cuForm
      [subjects]="contactUsMessage !== CONTACTUS_SUGGESTION ? contactUsSubjects : suggestContentSubjects"
      [userEmail]="loggedInUser?.user || ''"
      [firstName]="loggedInUser?.givenName || ''"
      [lastName]="loggedInUser?.surname || ''"
      [subjectsPerRow]="1"
      [controlsOverrideTemplate]="CUButtons"
      (completionEmitter)="submitContactRequest($event)"
      (cancellationEmitter)="cancelContactRequest()">
      <h3>
        <i class="fal" [ngClass]="{ 'fa-comment-alt-lines': contactUsMessage === 'Contact Us', 'fa-question-circle': contactUsMessage !== 'Contact Us' && contactUsMessage !== CONTACTUS_REPORT_PROBLEM, 'fa-bug': contactUsMessage === CONTACTUS_REPORT_PROBLEM, 'fa-comment-edit': contactUsMessage === CONTACTUS_SUGGESTION }"></i>
        {{ contactUsMessage }}
        <span class="close" style="color: white;" title="Close form" aria-roledescription="close button" aria-label="Close contact form button" (click)="cuForm.cancel()">&times;</span>
      </h3>
    </lib-contact-us-form>
  </div>
  <!-- [isHandset] = "isHandset"-->
  <lib-starbase-menubar id="mainMenuBar" #mainMenuBar style="z-index: 199;" [ngClass]="{'testingMode': testMode, 'mobile': isHandset}" [borderCss]="'3px solid #b01f23'"  [backgroundCss]="'#e5e6e7'" [foregroundCss]="'#ffffff'" [appLogoTemplate]="brand" [imageSrc]="" [darkMode]="darkMode" [glassMode]="glassMode" [appName]="" [appVersion]="version" [showStarbaseTag]="false" [displayName]="displayName" [user]="loggedInUser" (optionsEmitter)="showOptions()" [unreadNotifications]="numberOfUnreadNotifications()"  
  [avatarImage]="OVCAvatarImage" [avatarMode]="true" (editAvatarEmitter)="editAvatar()"
  [appLinksTemplate]="menuLinks"  [mobileNavItems]="mobileMenuLinks" (logoutEmitter)="logOut()" (showHelpEmitter)="showHelp()" (showNotificationsEmitter)="toggleNotificationHistory()"></lib-starbase-menubar>

  <div [@routeAnimation] style="background-color: #f5f5f5" (click)="hideOverlays()" (keyup.escape)="hideOverlays()">
    <router-outlet #routerOutlet="outlet"></router-outlet>
  </div>
  <!-- <app-notification-history-wrapper #notiHistory></app-notification-history-wrapper> -->
  <lib-starbase-notification-history #notiHistory [darkMode]="darkMode" [glassMode]="glassMode"></lib-starbase-notification-history>

  <div class="helpDeskWrapper" [ngClass]="{'activate': helpDisplayed}">
    <!-- <lib-help-desk #helpDesk *ngIf="helpDisplayed" [helpModelsForView]="helpDataActiveSet" [displayAllForView]=true (helpDismissEmitter)="hideHelpModal()"> -->
    <!-- </lib-help-desk> -->
  </div>
<!--</app-pull-to-refresh>-->

<!-- <ng-template #OVCAvatarTemplate>

  <div  style="width: 85px"(mouseover)="doHoverAvatar(true)" (mouseleave)="doHoverAvatar(false)">

    <div class="contactAvatarCircle" [style]="'background-image: url(' + getLogoPath() + ');'">
      <div class="overlay"  *ngIf="hoverAvatar"></div>
    </div>

    <i class="fal fa-pencil editPencil" *ngIf="hoverAvatar" title="Edit image" (click)="editAvatar($event)" ></i>
    
  </div>
</ng-template>


<ng-template #defaultAvatarTemplate>

  <div  style="width: 85px"(mouseover)="doHoverAvatar(true)" (mouseleave)="doHoverAvatar(false)">

    <div class="contactAvatarCircle" [style]="'background-image: url(/assets/def1.png);'">
      <div class="overlay"  *ngIf="hoverAvatar"></div>
    </div>

    <i class="fal fa-pencil editPencil" *ngIf="hoverAvatar" title="Edit image" (click)="editAvatar($event)" ></i>
    
  </div>
</ng-template> -->